import type { ReactNode } from 'react';
import { Plural, useGT } from 'gt-react';
import { BoardSectionHeader } from './BoardSectionHeader';

interface BuyingFiltersHeaderProps {
  collapsed: boolean;
  onToggle: () => void;
  controlsId: string;
  /** The read-only active-filter line shown while folded. */
  summary: string;
  search: string;
  onSearchChange: (value: string) => void;
  totalRows: number;
  vendorGrouping: boolean;
  exportButton: ReactNode;
  refreshButton: ReactNode;
  /** When the board's data last updated (GEN-3149). */
  freshness?: ReactNode;
}

/** The Filters section's one line: summary, search, count and actions. */
export function BuyingFiltersHeader({
  collapsed,
  onToggle,
  controlsId,
  summary,
  search,
  onSearchChange,
  totalRows,
  vendorGrouping,
  exportButton,
  refreshButton,
  freshness,
}: BuyingFiltersHeaderProps) {
  const gt = useGT();
  return (
    <BoardSectionHeader
      label={gt('Filters', { context: 'buying board section label' })}
      collapsed={collapsed}
      onToggle={onToggle}
      controlsId={controlsId}
      summary={summary}
    >
      {freshness}
      <input
        type="text"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={gt('Search vendors or warehouses', {
          context: 'replenishment search placeholder',
        })}
        aria-label={gt('Search vendors or warehouses', {
          context: 'replenishment search placeholder',
        })}
        className="h-6 w-[200px] shrink-0 rounded-md border border-border bg-background px-2 text-xs focus:outline-none focus:ring-2 focus:ring-ring"
      />
      <span className="shrink-0 whitespace-nowrap text-xs tabular-nums text-muted-foreground">
        {totalRows.toLocaleString()}{' '}
        {vendorGrouping ? (
          <Plural n={totalRows} one="vendor" other="vendors" />
        ) : (
          <Plural n={totalRows} one="order" other="orders" />
        )}
      </span>
      {exportButton}
      {refreshButton}
    </BoardSectionHeader>
  );
}
